import Empty from "./Cells/Empty";
import SectionWeight from "./Cells/SectionWeight";
import Type from "./Cells/Type";
import Value from "./Cells/Value";
import { Position } from "./hooks/useGetPositionRows";

type Col = {
	id: string;
	label: string;
	Cell: (props: Position) => JSX.Element | null;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "name",
		Cell: Type,
		align: "left",
		label: "result_demo.name"
	},
	{
		id: "isin",
		Cell: Empty,
		align: "center",
		label: "ISIN"
	},
	{
		id: "exchange",
		Cell: Empty,
		label: "result_demo.market",
		align: "center"
	},
	{
		id: "localAmount",
		Cell: Empty,
		align: "center",
		label: "result_demo.localAmount"
	},
	{
		id: "localPrice",
		Cell: Empty,
		align: "center",
		label: "result_demo.localPrice"
	},
	{
		id: "titles",
		Cell: Empty,
		align: "center",
		label: "result_demo.titles"
	},
	{
		id: "amount",
		Cell: Value,
		align: "center",
		label: "result_demo.amount"
	},
	{
		id: "weight",
		Cell: SectionWeight,
		align: "center",
		label: "result_demo.weight"
	}
];

export default cols;
